<template>
	<div class="app-progressbar">
    <p>Krok {{ current }} z {{ max }}</p>
    <div class="progress">
      <span v-for="step in max"
            v-bind:class="{'progressbar-item': true, 'step-ok': step < current, 'step-current': step == current, 'step-no': step > current}">
          <router-link v-if="step <= current" :to="{ name: stepsUrl[step - 1] }"></router-link>
      </span>
    </div>
	</div>
</template>

<script>
  export default {
    props: {
      current: {
        type: Number,
        required: true
      },
      max: {
        type: Number,
        required: true
      }
    },
    data: function () {
      return {
        stepsUrl: [
          'jmenomazlicka',
          'rasa',
          // 'fotografie',
          'narozeniny',
          'pohlavi',
          'hmotnostkondice',
          'pohyb',
          'alergie',
          'suroviny',
          'hotovekrmivo'
        ]
      }
    },
    computed: {}
  }
</script>



// WEBPACK FOOTER //
// ProgressBar.vue?298536aa